/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_Point_1_LabelInputs */

const en_visa_eb4_point_1_label = /** @type {(inputs: Visa_Eb4_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fact-Based Analysis`)
};

const pt_visa_eb4_point_1_label = /** @type {(inputs: Visa_Eb4_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise Baseada em Fatos`)
};

const es_visa_eb4_point_1_label = /** @type {(inputs: Visa_Eb4_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis Basado en Hechos`)
};

/**
* | output |
* | --- |
* | "Fact-Based Analysis" |
*
* @param {Visa_Eb4_Point_1_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_point_1_label = /** @type {((inputs?: Visa_Eb4_Point_1_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_Point_1_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_point_1_label(inputs)
	if (locale === "es") return es_visa_eb4_point_1_label(inputs)
	return en_visa_eb4_point_1_label(inputs)
});